module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAQCAMAAABA3o1rAAAAQlBMVEUAAACqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqrDGsyVAAAAFnRSTlMA/vhH6fNB7DTuVIQunp2McGw8IxwaWU9GagAAAIVJREFUKM99kFkOBCEIBVlc0N63+191yGQ6jGnp+pLUExGQWcBFJoE5E3ueKU8gGCj1faKAojFN1J6v6vkbxBy3p99ixl/rEUscrlZfQyw43tX5X9mdE4xV++1W7vrq2p9IceZOluD+z5kCsR1a7KK1chK1ev5ema2nh2ApKPDCsSwHNHwA8iUDi6EMHsQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.png
// module id = 3
// module chunks = 0